export default __webpack_public_path__ + "static/media/1684_ritning.e6ff35cb.jpg";